export default {
    methods: {
      fileSizeToString(size) {
        if (size < 1000) {
          return size.toFixed(0) + " 字节";
        } else if (size < 1000000) {
          return (size / 1024).toFixed(2) + "kB";
        } else if (size < 1000000000) {
          return (size / 1048576).toFixed(2) + "MB";
        } else {
          return (size / 1073741824).toFixed(2) + "GB";
        }
      }
    },
  };
  